import React from 'react'
import PropTypes from 'prop-types'

import Count from './common/Count'
import TimeAgo from './common/TimeAgo'
import Avatar from './common/Avatar'
import {getUser} from "../utils";
import cn from "classnames";

const Users = ({edges, pageInfo, onLoadMore}) => {
    return (

        <div className="w-100">
            <div className="card">
                <div className="card-header pricing-card-header">
                    {/*<i className="fa fa-align-justify"></i>*/}
                    <span><strong>Admin Users</strong></span>
                    {/*<span className="text-muted float-right"><i className="fa fa-info-circle"/> Email hello@jellyfish.chat to assign other people in your organization as admins</span>*/}
                    {/*<span className="text-muted float-right"><i className="fa fa-info-circle"/> Admins are synchronized from your Slack workspace user account type settings.</span>*/}
                    {/*<span className="text-muted float-right d-sm-down-none"><i className="fa fa-info-circle"/> Users who are administrators of your Slack workspace are automatically assigned an admin role.</span>*/}
                    {/*<span className="text-muted d-sm-down-none ml-3"><i className="fa fa-info-circle"/> Users who are administrators of your Slack workspace are automatically assigned an admin role.</span>*/}
                </div>
                <div className="card-body">

                    {/*<table className="table borderless table-responsive-sm table-sm">*/}

                        <div className="row d-sm-down-none mb-1">
                            {/*<div className="col-1"></div>*/}
                            <div className="col-3"><strong></strong></div>
                            <div className="col-3 d-sm-down-none"><strong>Email</strong></div>
                            <div className="col-2 d-sm-down-none"><strong>Joined</strong></div>
                            <div className="col-2 d-sm-down-none"><strong>Last Active</strong></div>
                            <div className="col-1"><strong>Role</strong></div>
                        </div>

                        {edges.map(({node: user}) => (


                            <div className="row py-1">

                                    {/* mobile only */}
                                    <div className="d-md-none col-12">
                                        <span className="ml-3"><Avatar width={30} src={user.slackImage48} /></span>
                                        <span className="px-4">{user.slackRealName}</span>
                                        <span className={cn('badge mr-3 float-right', user.isOrganizationAdmin ? 'badge-primary' : 'badge-secondary')}>{user.isOrganizationAdmin?'Admin':'User'}</span>
                                    </div>

                                    {/* non mobile only */}
                                    <div className="d-none d-md-block col-3">
                                        <span className=""><Avatar width={30} src={user.slackImage48} /></span>
                                        <span className="pl-3">{user.slackRealName}</span>
                                    </div>
                                    {/*<div className="d-none d-md-block col-2">*/}
                                    {/*    <span className="">{user.slackRealName}</span>*/}
                                    {/*</div>*/}
                                    <div className="d-none d-md-block col-3">{user.email}</div>
                                    <div className="d-none d-md-block col-2"><TimeAgo date={user.dateJoined} className="text-muted"/></div>
                                    <div className="d-none d-md-block col-2"><TimeAgo date={user.updated} className="text-muted"/></div>
                                    <div className="d-none d-md-block col-1">
                                        <span className={cn('badge', user.isOrganizationAdmin ? 'badge-primary' : 'badge-secondary')}>{user.isOrganizationAdmin?'Admin':'User'}</span>
                                    </div>

                            </div>


                            ))}

                    <div className="row mt-3">
                        <div className="text-muted d-sm-down-none ml-3 float-right"><i className="fa fa-info-circle"/> Users who are administrators of your Slack workspace are automatically assigned an admin role.</div>
                    </div>

                    {/*<ul className="pagination">*/}

                    {/*    {pageInfo.hasNextPage ? (*/}
                    {/*        <div className="col-lg-4 offset-lg-4 text-center">*/}
                    {/*            <button className="btn btn-primary" onClick={onLoadMore}>*/}
                    {/*                Show more*/}
                    {/*            </button>*/}
                    {/*        </div>*/}
                    {/*    ) : null}*/}


                    {/*    /!*<li className="page-item">*!/*/}
                    {/*        /!*<a className="page-link" href="#">Prev</a>*!/*/}
                    {/*    /!*</li>*!/*/}
                    {/*    /!*<li className="page-item active">*!/*/}
                    {/*        /!*<a className="page-link" href="#">1</a>*!/*/}
                    {/*    /!*</li>*!/*/}
                    {/*    /!*<li className="page-item">*!/*/}
                    {/*        /!*<a className="page-link" href="#">2</a>*!/*/}
                    {/*    /!*</li>*!/*/}
                    {/*    /!*<li className="page-item">*!/*/}
                    {/*        /!*<a className="page-link" href="#">3</a>*!/*/}
                    {/*    /!*</li>*!/*/}
                    {/*    /!*<li className="page-item">*!/*/}
                    {/*        /!*<a className="page-link" href="#">4</a>*!/*/}
                    {/*    /!*</li>*!/*/}
                    {/*    /!*<li className="page-item">*!/*/}
                    {/*        /!*<a className="page-link" href="#">Next</a>*!/*/}
                    {/*    /!*</li>*!/*/}
                    {/*</ul>*/}

                </div>
            </div>
            </div>
        // </div>

    )
}

Users.propTypes = {
    edges: PropTypes.array.isRequired,
    pageInfo: PropTypes.object.isRequired,
    onLoadMore: PropTypes.func.isRequired,
}

export default Users



// WEBPACK FOOTER //
// ./src/components/Users.jsx